import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const BASE_URLS = {
  test: 'https://test-psafe.pro-vigil.us:8026',
  uat: 'https://pro-safe-sandbox.pro-vigil.info:8026',
  prod: 'https://pro-safe.pro-vigil.info:8026'
};

@Injectable({ providedIn: 'root' })
export class ArchiveDashboardService {
  private baseUrl = BASE_URLS[environment.env] || BASE_URLS.test;

  static isAdminUser(email: string): boolean {
    if (!email) return false;
    const lower = email.toLowerCase();
    return lower.includes('sudarshan.chippa@pro-vigil.com') || lower.includes('khajahaneef.shaik@pro-vigil.com');
  }

  constructor(private http: HttpClient) {}

  setEnv(env: string) {
    this.baseUrl = BASE_URLS[env] || BASE_URLS.test;
    console.log('Service Base URL:', this.baseUrl);
  }

  getQueueStatus() {
    return this.http.get(`${this.baseUrl}/api/hd/queue/status`);
  }
  getAllArchives(page = 0, size = 200, sort = 'createdDateTime,desc', source?: string, includeDeleted?: boolean) {
    let url = `${this.baseUrl}/api/hd/archives/all?page=${page}&size=${size}&sort=${sort}`;
    if (source) {
      url += `&source=${encodeURIComponent(source)}`;
    }
    if (includeDeleted !== undefined) {
      url += `&includeDeleted=${includeDeleted}`;
    }
    console.log('Calling All Archives URL:', url);
    return this.http.get(url);
  }
  getRunningJobs(source?: string) {
    let url = `${this.baseUrl}/api/hd/archives/running`;
    if (source) {
      url += `?source=${encodeURIComponent(source)}`;
    }
    console.log('Calling Running Jobs URL:', url);
    return this.http.get(url);
  }
  getPendingJobs(source?: string) {
    let url = `${this.baseUrl}/api/hd/archives/pending`;
    if (source) {
      url += `?source=${encodeURIComponent(source)}`;
    }
    return this.http.get(url);
  }
  cancelAllJobs() {
    return this.http.post(`${this.baseUrl}/api/hd/archives/cancel-all`, {});
  }
  cancelAllPendingJobs() {
    return this.http.post(`${this.baseUrl}/api/hd/archives/cancel-all-pending`, {});
  }
  getArchiveLogs(archiveId: string) {
    return this.http.get(`${this.baseUrl}/api/hd/archives/${archiveId}/logs`);
  }
  cancelJob(archiveId: string) {
    return this.http.post(`${this.baseUrl}/api/hd/archives/${archiveId}/cancel`, {});
  }
  rerunJob(archiveId: string) {
    return this.http.post(`${this.baseUrl}/api/hd/archive/rerun/${archiveId}`, {});
  }
  softDeleteArchive(archiveId: string) {
    return this.http.post(`${this.baseUrl}/api/hd/archives/${archiveId}/soft-delete`, {});
  }
} 